"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.form.title.edit': '编辑行业',
    'branch.form.title.add': '添加行业',
    'branch.form.back': '返回',
    'branch.form.name.label': '名称',
    'branch.form.name.placeholder': '行业名称',
    'branch.form.color.label': '颜色',
    'branch.form.color.placeholder': '行业颜色',
    'branch.form.description.label': '描述',
    'branch.form.description.placeholder': '描述',
    'branch.form.submit.update': '更新行业',
    'branch.form.submit.create': '创建行业',
};
